import { createContext } from 'react';

import { CategoricalBarChartTooltipConfiguration } from '../types/categorical-bar-chart.js';
import { defaultConfig } from '../types/defaults.js';

export const CategoricalBarChartTooltipContext =
  createContext<CategoricalBarChartTooltipConfiguration>(defaultConfig.tooltip);
